export default __webpack_public_path__ + "6876aea9.svg";